// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"60cae085","275":"0a0eadc9","302":"3df7de35","720":"fae33cf1"}[chunkId] + ".css";
};